import { Autocomplete, TextField } from '@mui/material'
import { setItemToLocalStorage, getItemFromLocalStorage } from '../common/LocalStorage'

export const YearSelectInput = ({ label, minWidth, options = [], ...rest }) => {
  // Get current year from localStorage or default to actual current year
  const getCurrentYear = () => {
    const storedYear = getItemFromLocalStorage('localCurrentYear')
    if (storedYear) {
      return storedYear
    }
    
    // If no stored year, find current year in options or default to current year
    const currentYear = new Date().getFullYear()
    return options.find(option => option.name === currentYear.toString()) || 
           options.find(option => parseInt(option.name) === currentYear) ||
           null
  }

  const handleValidation = (currentYear) => {
    if (currentYear === null) return
   
    setItemToLocalStorage('localCurrentYear', currentYear)
    window.location.reload(true)
  }

  return (
    <Autocomplete
      options={options}
      autoComplete
      includeInputInList
      value={getCurrentYear()}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      sx={{ minWidth: minWidth }}
      renderInput={(params) => <TextField {...params} variant="outlined" placeholder={label} />}
      {...rest}
      onChange={(event, newValue) => handleValidation(newValue ?? null)}
    />
  )
}

export const CustomSelectInput = ({ label, minWidth, ...rest }) => (
  <Autocomplete
    disablePortal
    autoComplete
    includeInputInList
    getOptionLabel={(option) => option.label}
    isOptionEqualToValue={(option, value) => option.value === value.value}
    sx={{ minWidth: minWidth }}
    renderInput={params => <TextField {...params} variant="outlined" placeholder={label} />}
    {...rest}
  />
)